import apiClient from '~/services/api.service';
export const productService = {
    // async index(payload = {}) {
    //     return apiClient.get("products", { params: payload });
    // },

    async index(payload = {}) {
        const params = { ...payload };

        // Handle filters for WooCommerce
        if (payload.filters) {
            payload.filters.forEach((filter) => {
                if (filter.type === "variant") {
                    const attrKey = `attribute_${filter.slug || `pa_${filter.name.toLowerCase()}`}`;
                    if (!params[attrKey]) params[attrKey] = [];
                    params[attrKey].push(filter.value);
                } else if (filter.type === "category") {
                    params.category = filter.value;
                } else if (filter.type === "brand") {
                    params.brand = filter.value;
                }
            });

            delete params.filters;
        }

        return apiClient.get("products", { params });
    },


    async getProduct(id) {
        return apiClient.get(`products/${id}`);
    },

    async getVariations(id) {
        return apiClient.get(`products/${id}/variations`);
    },


    async getDiscountedProducts(payload = {}) {
        const params = { on_sale: true, ...payload };
        return apiClient.get("products", { params });
    },

    async getNewArrivalProducts(payload = {}) {
        const params = { orderby: 'date', order: 'desc', ...payload };
        return apiClient.get("products", { params });
    },

    async getFeaturedProducts(payload = {}) {
        const params = { featured: true, ...payload };
        return apiClient.get("products", { params });
    },
};